import { ITPA } from '@wix/podcasts-common/dist/tpa';

interface ITPABIContext {
  _msid: string;
  _appId: string;
  _instanceId: string;
  _siteOwnerId: string;
  _siteMemberId: string;
  _visitorId: string;
  _viewMode: string;
  compId: string;
  bsi: string;
}

// NOTE: inspired by https://github.com/wix-private/bi-logger/blob/master/iframe-app-bi-context

function getBsi(commonConfig: string) {
  try {
    return JSON.parse(commonConfig).bsi;
  } catch (e) {
    return null;
  }
}

function getTPABIContext(tpa: ITPA): ITPABIContext {
  return {
    _msid: tpa.instance.metaSiteId,
    _appId: tpa.instance.appDefId,
    _instanceId: tpa.instance.instanceId,
    _siteOwnerId: tpa.instance.siteOwnerId,
    _siteMemberId: tpa.instance.uid || '',
    _visitorId: tpa.instance.aid,
    _viewMode: tpa.params.viewMode,
    // NOTE: don't know why `iframe-app-bi-context` does not add it :/
    compId: tpa.params.compId,
    bsi: getBsi(tpa.params.commonConfig),
  };
}

export default getTPABIContext;
